import { AgxService, PoisonQueueMessage } from '@urbanx/agx.support.client'
import { AgxTypography } from '@urbanx/agx.ui-components2'
import LoadingState from 'components/loadingState/LoadingState'
import Panel from 'components/panel/Panel'
import dayjs from 'dayjs'
import { useMemo } from 'react'

interface PoisonQueueMessageDetailsProps {
  service?: AgxService
  queueName?: string
  queueMessage?: PoisonQueueMessage
  isPending: boolean
}

const PoisonQueueMessageDetails = ({
  service,
  queueName,
  queueMessage,
  isPending,
}: PoisonQueueMessageDetailsProps) => {
  const messageBodyText = useMemo(() => {
    if (!queueMessage?.messageBodyJson) return '-'

    const parsedJson = JSON.parse(queueMessage.messageBodyJson)

    return JSON.stringify(parsedJson, null, 2)
  }, [queueMessage?.messageBodyJson])

  if (!service) return null;

  return (
    <Panel title="Poison Queue Message Details">
      {isPending && <LoadingState />}

      {!isPending && (
        <>
          <AgxTypography
            id={'poison-queue-message-service'}
            type={'body_ui'}
            size={'small'}
          >
            <b>Service: </b> {service ?? '-'}
          </AgxTypography>
          <AgxTypography
            id={'poison-queue-message-queue'}
            type={'body_ui'}
            size={'small'}
          >
            <b>Queue: </b> {queueName ?? '-'}
          </AgxTypography>
          <AgxTypography
            id={'poison-queue-message-id'}
            type={'body_ui'}
            size={'small'}
          >
            <b>Message Id: </b> {queueMessage?.id ?? '-'}
          </AgxTypography>
          <AgxTypography
            id={'poison-queue-message-insertedAt'}
            type={'body_ui'}
            size={'small'}
          >
            <b>Inserted At: </b>
            {!queueMessage?.insertionTime
              ? '-'
              : dayjs(queueMessage.insertionTime).format(
                  'DD/MM/YYYY h:mm:ss A'
                )}
          </AgxTypography>
          <AgxTypography
            id={'poison-queue-message-expiresAt'}
            type={'body_ui'}
            size={'small'}
          >
            <b>Expires At: </b>
            {!queueMessage?.expirationTime
              ? '-'
              : dayjs(queueMessage.expirationTime).format(
                  'DD/MM/YYYY h:mm:ss A'
                )}
          </AgxTypography>

          <AgxTypography
            id={'poison-queue-message-dequeueCount'}
            type={'body_ui'}
            size={'small'}
          >
            <b>Dequeue Count: </b>
            {queueMessage?.dequeueCount ?? '-'}
          </AgxTypography>

          <AgxTypography
            id={'poison-queue-message-messageBodyLabel'}
            type={'body_ui'}
            size={'small'}
          >
            <b>Message Body: </b>
          </AgxTypography>

          <AgxTypography
            id={'poison-queue-message-body'}
            type={'body_ui'}
            size={'small'}
          >
            <pre
              style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: 'inherit',
                fontFamily: 'inherit',
              }}
            >
              {messageBodyText}
            </pre>
          </AgxTypography>
        </>
      )}
    </Panel>
  )
}

export default PoisonQueueMessageDetails
